import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import PropTypes from "prop-types";
import { useTimeSheetSummary } from "hooks";
import { TimeSheetChart } from "components/Missions/TimeSheets";
import { margins } from "style";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import Card from "components/Card";
import { formatHours } from "utils";
import { css } from "@emotion/react";

/**
 * TimeSheetChart
 *
 * @param {Object} team
 */
const TeamTimeSheeChart = ({ team }) => {
  if (!team) return null;

  const todayWeek = moment().isoWeek();
  const year = moment().isoWeekYear();
  const [week, setWeek] = useState(todayWeek);
  const { loading, data, error } = useTimeSheetSummary({ week, year, teamId: team.slug });

  return (
    <Card key={team?.name}>
      <Header marginSize={margins.normal}>
        <H3>{team?.name}</H3>
        <div>
          <FormattedMessage
            id="Missions.TimeSheets.TimeSheetSummary"
            values={{
              completedHours: <b>{formatHours(data?.timeSheetSummary?.completedMinutes, false)}</b>,
              allocatedHours: <b>{formatHours(data?.timeSheetSummary?.allocatedMinutes, false)}</b>,
            }}
          />
        </div>
      </Header>
      <div css={styles.time_data}>
        <TimeSheetChart
          data={data?.timeSheetSummary?.timesheetData || []}
          billableMonth={data?.timeSheetSummary?.billableMonth}
          week={week}
          onWeekChange={setWeek}
          loading={loading}
          error={error}
        />
      </div>
    </Card>
  );
};

const styles = {
  time_data: css`
    width: 100%;
  `,
};

TeamTimeSheeChart.propTypes = {
  team: PropTypes.object,
};

export default TeamTimeSheeChart;
